/** @format */

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../button';

export const TicketInfo = ({ data }) => {
  const { t } = useTranslation();
  const [showLongDescription, setShowLongDescription] = React.useState(false);
  const descriptionRef = React.useRef(null);
  const shortDescriptionRef = React.useRef(null);
  const longDescriptionRef = React.useRef(null);

  const shortDescription = data.description.length > 300 ? data.description.slice(0, 300) : data.description;
  const longDescription = data.description.length > 300 ? data.description.slice(300) : '';

  React.useEffect(() => {
    if (descriptionRef.current && shortDescriptionRef.current && longDescriptionRef.current) {
      if (showLongDescription) {
        descriptionRef.current.style.height = `${longDescriptionRef.current.offsetHeight}px`;
      } else {
        descriptionRef.current.style.height = `${shortDescriptionRef.current.scrollHeight}px`;
      }
    }
  }, [showLongDescription]);

  return (
    <div className="ticket-info">
      <div className="ticket-title">
        <p>
          <strong>{t('Tickets.caseTitle')}</strong>
        </p>
        <p>{data.title}</p>
      </div>
      <div className="ticket-description">
        <p>
          <strong>{t('Tickets.caseDescription')}</strong>
        </p>
        <div className="ticket-description-content" ref={descriptionRef}>
          <p className={`short-description ${showLongDescription ? 'hide' : ''}`} ref={shortDescriptionRef}>
            {shortDescription}
            {!showLongDescription && longDescription !== '' && <span className="dot-dot-dot">...</span>}
          </p>
          {longDescription !== '' && (
            <p className={`long-description ${showLongDescription ? 'show' : ''}`} ref={longDescriptionRef}>
              {data.description}
            </p>
          )}
        </div>
        {longDescription !== '' && (
          <div className="show-more-button">
            <Button
              secondary
              noArrow
              label={showLongDescription ? t('Tickets.readLess') : t('Tickets.readMore')}
              onClick={() => setShowLongDescription(!showLongDescription)}
            />
          </div>
        )}
      </div>

      {/* Additional ticket details */}
      {data.project && (
        <div className="ticket-additional-field ticket-component">
          <p>
            <strong>{t('Tickets.component')}: </strong>
          </p>
          <p>
            {data.project}
            {data.subProject ? ` / ${data.subProject}` : ''}
          </p>
        </div>
      )}

      {data.ava_vrnnumber && (
        <div className="ticket-additional-field ticket-vrn">
          <p>
            <strong>{t('Tickets.vehicleRegistrationNumber')}: </strong>
          </p>
          <p>{data.ava_vrnnumber}</p>
        </div>
      )}

      {data.smy_affecteddriver && (
        <div className="ticket-additional-field ticket-affected-driver">
          <p>
            <strong>{t('Tickets.affectedDriver')}: </strong>
          </p>
          <p>{data.smy_affecteddriver}</p>
        </div>
      )}

      {data.smy_companycardnumber && (
        <div className="ticket-additional-field ticket-company-card">
          <p>
            <strong>{t('Tickets.companyCardNumber')}: </strong>
          </p>
          <p>{data.smy_companycardnumber}</p>
        </div>
      )}

      {data.smy_deviceserialnumber && (
        <div className="ticket-additional-field ticket-device-serial">
          <p>
            <strong>{t('Tickets.deviceSerialNumber')}: </strong>
          </p>
          <p>{data.smy_deviceserialnumber}</p>
        </div>
      )}
    </div>
  );
};
